import { deprecated } from 'typesafe-actions';

const { createStandardAction } = deprecated;

export const emailUnsubscribe = createStandardAction('emailUnsubscribe/UNSUBSCRIBE')<string>();
export const emailUnsubscribeSuccess = createStandardAction('emailUnsubscribe/UNSUBSCRIBE_SUCCESS')();
export const emailUnsubscribeFailure = createStandardAction('emailUnsubscribe/UNSUBSCRIBE_FAILURE')();